import { useEffect, useRef, useState } from "react";
import OddsChangePopup from "@/components/OddsChangePopup";

const POPUP_W = 580;

const THEME_VARS = [
  "--theme-bg",
  "--theme-bg-muted",
  "--theme-foreground",
  "--theme-primary",
  "--theme-primary-hover",
  "--theme-glow",
  "--theme-text",
  "--theme-text-muted",
  "--theme-subtext",
  "--theme-accent",
  "--theme-border",
  "--theme-highlight",
  "--theme-on-primary",
  "--theme-btn-border",
  "--text-half-score",
  "--theme-table-header-bg-start",
  "--theme-table-header-bg-end",
];

function computePos(el) {
  const r = el.getBoundingClientRect();
  const width = Math.min(POPUP_W, window.innerWidth - 16);
  let left = r.right - width;
  left = Math.min(Math.max(8, left), window.innerWidth - width - 8);
  const estH = 360;
  let top = r.bottom + 8;
  if (top + estH > window.innerHeight - 8) {
    top = Math.max(8, r.top - estH - 8);
  }
  return { top, left };
}

function readPortalTheme(el) {
  const root = el?.closest(".keobongvip-root");
  const host =
    el?.closest(".kbv-ltd-full") ||
    el?.closest("[style*='--theme-']") ||
    root;
  const themeStyle = {};
  if (host) {
    const cs = getComputedStyle(host);
    for (const key of THEME_VARS) {
      const value = cs.getPropertyValue(key).trim();
      if (value) themeStyle[key] = value;
    }
  }
  return {
    theme: root?.getAttribute("data-theme") || undefined,
    themeStyle,
  };
}

export default function MatchOddPopup({ enabled, match, children }) {
  const wrapRef = useRef(null);
  const closeTimer = useRef(0);
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const [theme, setTheme] = useState();
  const [themeStyle, setThemeStyle] = useState();

  const syncPos = () => {
    if (wrapRef.current) setPos(computePos(wrapRef.current));
  };

  const show = () => {
    window.clearTimeout(closeTimer.current);
    const next = readPortalTheme(wrapRef.current);
    setTheme(next.theme);
    setThemeStyle(next.themeStyle);
    syncPos();
    setOpen(true);
  };

  const hideSoon = () => {
    closeTimer.current = window.setTimeout(() => setOpen(false), 140);
  };

  useEffect(() => {
    if (!open) return undefined;
    const onWin = () => syncPos();
    window.addEventListener("scroll", onWin, true);
    window.addEventListener("resize", onWin);
    return () => {
      window.removeEventListener("scroll", onWin, true);
      window.removeEventListener("resize", onWin);
    };
  }, [open]);

  useEffect(() => () => window.clearTimeout(closeTimer.current), []);

  if (!enabled) return children;

  return (
    <div
      ref={wrapRef}
      className="relative"
      onMouseEnter={show}
      onMouseLeave={hideSoon}
      onClick={(e) => {
        if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
        e.stopPropagation();
        if (open) setOpen(false);
        else show();
      }}
    >
      {children}
      {open ? (
        <OddsChangePopup
          match={match}
          visible
          position={pos}
          portal
          gridLines
          theme={theme}
          themeStyle={themeStyle}
          onClose={() => setOpen(false)}
          onPanelEnter={show}
          onPanelLeave={hideSoon}
        />
      ) : null}
    </div>
  );
}
